"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useObservable = void 0;
const react_1 = require("react");
const useObservable = (observable, defaultValue) => {
    const [value, setValue] = (0, react_1.useState)(defaultValue);
    const [error, setError] = (0, react_1.useState)(undefined);
    const [loading, setLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        if (!observable)
            return;
        const sub = observable.subscribe({
            next: (newValue) => {
                setLoading(false);
                setValue(newValue);
            },
            error: (error) => setError(error)
        });
        return () => sub.unsubscribe();
    }, [observable]);
    return [value, loading, error];
};
exports.useObservable = useObservable;
//# sourceMappingURL=use-observable.js.map